export const gameLoop = (passDiff) => {

  let diff = passDiff;
  const thisUpdate = Date.now();
  const realDiff = diff === undefined
  ? Math.clamp(thisUpdate - player.lastUpdate, 1, 8.64e7)
  : diff;
  console.log(realDiff);
// if (!GameStorage.ignoreBackupTimer) player.backupTimer += realDiff;
};